module.exports = __webpack_public_path__ + "7d48c2dc79791b2bcc0c000018366afb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/step3.png
// module id = 871
// module chunks = 3